import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Paper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { imageBoxStyle, imageStyle, tableBoxStyle, tableTextStyle, titleStyle } from './PhotoVerfDialog-css'
import { fetchPhotoVerfRequests, getWORKerImage, getWORKerImageDashboard, updatePhotoVerfStatus } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import { maroon, mediumGrey, red, textColor } from '../../../assets/colors'
import { buttonStyle, errorStyleText } from '../../formStyle'
import Loader from '../../Loader'
import { useNavigate } from 'react-router-dom'

const PhotoVerfDialog = (props) => {

    const [requestsList, setRequestsList] = useState([])
    const [selectedIndex, setSelectedIndex] = useState(null)
    const [selectedContactNumber, setSelectedContactNumber] = useState(null)
    const [url, setUrl] = useState(null)
    const [updateStatus, setUpdateStatus] = useState(null)
    const [isrefresh, setRefresh] = useState(null)
    const [isLoader, setIsLoader] = useState(false)
    const [msg, setMsg] = useState('No Photos to verify.')
    const [errorMsg, setErrorMsg] = useState(null)

    useEffect( ()=> {
        setRequestsList([])
        setSelectedIndex(null)
        setSelectedContactNumber(null)
        setUrl(null)
        setUpdateStatus(null)
        setRefresh(null)
        setErrorMsg(null)
    }, [])

    const navigate = useNavigate()

    useEffect(() => {
        try{
            if( props.photoVerDialogStatus){
                setIsLoader(true)
                let options = {
                    url: fetchPhotoVerfRequests,
                    method:'GET',
                    params: {},
                    headers: {
                        Authorization: localStorage.getItem("token")
                        ? `Bearer ${localStorage.getItem("token")}`
                        : null,
                    }
                }
                HttpService(options).then(response => {
                    setRequestsList(response?.data?.data)
                    setRefresh(false)
                    setIsLoader(false)
                }).catch(err => {
                    console.log('Error in fetching photo verification requests list', err)
                    setIsLoader(false)
                    if (err?.status === 403) {
                    localStorage.clear();
                    navigate("/Login");
                } else {
                        console.log("Error in Fetching Verification List", err)
                        setMsg('Error in Fetching Verification List. Please Contact Support.')
                    }
                })
            }
        }catch(err){
            console.log('Error in fetching the list of the photo verification requests.', err)
            setMsg('Error in Fetching Verification List. Please Contact Support.')
            setIsLoader(false)
        }
    }, [props.photoVerDialogStatus, isrefresh])

    useEffect(() => {
        try{
            setUrl(null)
            if(selectedContactNumber){
                setIsLoader(true)
                let options = {
                    url: getWORKerImageDashboard,
                    method: 'GET',
                    params: {
                        contactNumber: selectedContactNumber
                    },
                    headers: {
                        Authorization: localStorage.getItem("token")
                        ? `Bearer ${localStorage.getItem("token")}`
                        : null,
                    }
                }
                HttpService(options).then(response => {
                    console.log("response: ", response)
                    setUrl(response?.data?.data?.data?.url)
                    setIsLoader(false)
                }).catch(err => {
                    console.log("Error in fetching the image.", err)
                    if (err?.status === 403) {
                        localStorage.clear();
                        setIsLoader(false)
                        navigate("/Login");
                    } else {
                        console.log("Error in Fetching Verification List", err)
                        setErrorMsg('Error in Fetching the Image. Please Contact Support.')
                        setIsLoader(false)
                    }   
                })
            }
        } catch(err){
            console.log("Error in fetching Image: ", err)
            setErrorMsg('Error in Fetching the Image. Please Contact Support.')
            setIsLoader(false)
        }
    }, [selectedContactNumber])

    useEffect(() => {
        try{
            if( (updateStatus === 'accepted' || updateStatus === 'rejected') && selectedContactNumber){
                setIsLoader(true)
                let options ={
                    url: updatePhotoVerfStatus,
                    method: 'POST',
                    payload: {
                        contactNumber: selectedContactNumber,
                        status: updateStatus
                    },
                    headers: {headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                    }}
                }
                HttpService(options).then(resp =>{
                    console.log('status updated')
                    setSelectedIndex(null)
                    setUrl(null)
                    setUpdateStatus(null)
                    setRefresh(true)
                    setIsLoader(false)
                }).catch(err => {
                    console.log('Error in updating status', err)
                    if (err?.status === 403) {
                        localStorage.clear();
                        setIsLoader(false)
                        navigate("/Login");
                    } else {
                        console.log("Error in Updating Status", err)
                        setErrorMsg('Error in Updating Status. Please Contact Support.')
                        setIsLoader(false)
                    }
                })
            }

        } catch(err){
            console.log('Error in updating status', err)
            setErrorMsg('Error in Updating Status. Please Contact Support.')
            setIsLoader(false)
        }
    }, [updateStatus])

  return (
    <>
    <Dialog maxWidth = 'xs' fullWidth open= {props.photoVerDialogStatus} onClose={() => {props.updatePhotoVerDialogStatus()}}>
        <DialogTitle style={titleStyle}>
            Verify Photo
        </DialogTitle>
        <DialogContent sx={{"&::-webkit-scrollbar":{
                    display: 'none'
                  },
                  scrollbarWidth: "none"}}>
            <Box style={tableBoxStyle} >
                {requestsList.length > 0 ? 
                <>
                    {requestsList?.map((request, index) => (
                        <>
                        <Paper style={{display: 'flex', flexDirection: 'row', border: `1px solid ${mediumGrey}`, borderRadius: 8, padding: '0.5rem', marginTop: '0.2rem'}}>
                            <Box style={{display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignItems: 'center', padding: '0.5rem 0rem 0rem 0rem'}}>
                            <Grid container direction='row' rowSpacing={1} columnSpacing={1} flexWrap='wrap'
                            // style={{alignItems: 'center'}}

                            >
                                <Grid item xs={6} sm={6} >
                                    <Typography style={tableTextStyle}>
                                        {request.name}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sm={2}>
                                    <Typography style={tableTextStyle}>
                                        {request.gender}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4} sm={4}>
                                    <Typography style={tableTextStyle}>
                                        {request.contactNumber}
                                    </Typography>
                                </Grid>
                            </Grid>
                                <Grid container direction='row' rowSpacing={1} columnSpacing={1} flexWrap='wrap'>
                                <Grid item xs={6} sm={6} >
                                    <Typography style={tableTextStyle}>
                                        {request.district}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} sm={6}>
                                    <Typography style={tableTextStyle}>
                                        {request.chapter}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} sm={6} style={{display:'flex', justifyContent: 'flex-end',}}>
                                    <Button style={{
                                        ...buttonStyle, 
                                        fontSize:'0.75rem', 
                                        padding: '0.1rem 0.2rem 0.1rem 0.2rem',
                                        opacity: selectedIndex  === index ? 1 : 0.5
                                    }}
                                    onClick={() => setUpdateStatus('accepted')}
                                    disabled = {!(selectedIndex  === index)}
                                    >Accept</Button>
                                </Grid>
                                <Grid item xs={6} sm={6}>
                                    <Button style={{
                                        ...buttonStyle, 
                                        backgroundColor: maroon, 
                                        fontSize:'0.75rem', 
                                        padding: '0.1rem 0.2rem 0.1rem 0.2rem',
                                        opacity: selectedIndex  === index ? 1 : 0.5
                                    }}
                                    disabled = {!(selectedIndex  === index)}
                                    onClick={() => {
                                        setUpdateStatus('rejected')
                                    }}
                                    >Reject</Button>
                                </Grid>
                            </Grid>
                            </Box>
                            {/* {selectedIndex === index &&  */}
                            <Box style={imageBoxStyle}
                            onClick={() => {
                                setSelectedContactNumber(request.contactNumber)
                                setSelectedIndex(index)
                            }}
                            >
                                <img style={imageStyle} src={selectedIndex === index && url ? url: require('../../../assets/images/leader.png')}></img>
                                <Typography style={{padding: '0.3rem 0rem 0rem 0rem', color: maroon, fontWeight: 600, fontSize: '0.9rem'}}>{request.id}</Typography>
                            </Box>
                            {/* } */}
                        </Paper>
                        </>
                    ))}
                    <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1rem 0.5rem 0.5rem 0.5rem'}}>
                        <Typography style={{color: maroon, fontSize: '1rem'}}> 
                            {errorMsg}
                        </Typography>
                    </Box>
                </> 
                
                :
                isLoader ? <Loader></Loader>:
                <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1rem 0.5rem 0.5rem 0.5rem'}}>
                    <Typography style={{color: maroon, fontSize: '1rem', fontWeight: 600}}> 
                        {msg}
                    </Typography>
                </Box>
                }
                
            </Box>
            

        </DialogContent>

    </Dialog>
    </>
  )
}

export default PhotoVerfDialog